import { ColumnOptions } from '../types/column-options';
import { DateColumn } from '../types/grid';
import { IsoDate } from '@softline/core';
import { ColumnHostRef } from '../types/refs';

export interface DateColumnOptions<TRow extends object> extends ColumnOptions<TRow, IsoDate>{
  format?: string;
  rowGroup?: boolean;
  pivot?: boolean;
}

export function dateColumn<TRow extends object>(ref: ColumnHostRef<TRow>,
                                                options: DateColumnOptions<TRow>): DateColumn<TRow> {
  const column: DateColumn<TRow> = {
    ...options,
    type: 'date',
    format: options.format ?? 'DATE.DEFAULT',
  }
  ref.createColumn(column);
  return column;
}
